module.exports = __webpack_public_path__ + "img/31.e56c522b.jpg";